import { media } from "components/styles/breakpoints";
import styled, { css } from "styled-components";

export const screenItemMixin = css`
  background-color: #43fffa06;
  border: 1px #43fffa20 solid;
  padding: 10px 12px;
  border-radius: 5px;
`;

export const highlightMixin = css`
  background-color: #43fffa12;
  border: 1px #43fffa60 solid;
  padding: 10px 12px;
  border-radius: 5px;
`;

export const DataScreen = styled.div`
  background-color: #00000099;
  backdrop-filter: blur(40px);
  color: white;
  z-index: 2;
  height: 100%;
`;

const hiddenMixin = css`
  opacity: 0;
  pointer-events: none;
  z-index: -1;
`;

export const ScreenContent = styled.div<{ isShowing: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  transition: opacity 200ms ease-in;
  ${({ isShowing }) => !isShowing && hiddenMixin}
`;

export const DataWrapper = styled.div`
  display: flex;
  padding: 4dvh;
  gap: 4dvh;
  height: calc(100% - 8dvh);
  overflow-y: scroll;
`;

export const Section = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
`;

export const SectionTitle = styled.div`
  text-transform: uppercase;
  color: #43fffa;
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 10px;
  line-height: 1;

  ${media.desktop`
    font-size: 24px;
    padding-bottom: 15px;
  `}
`;

export const SectionGroups = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SectionGroup = styled.div`
  ${screenItemMixin}
`;

export const SectionSubtitle = styled.div`
  color: #2da5b2;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 10px;

  ${media.desktop`
    font-size: 20px;
    margin-bottom: 15px;
  `}
`;

export const SectionContent = styled.div`
  flex-grow: 1;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const SectionContentScroll = styled(SectionContent)`
  overflow-y: scroll;
`;

export const CategoryGroup = styled.div`
  ${screenItemMixin}
`;

export const CategoryName = styled.div`
  font-weight: 600;
  text-transform: uppercase;
  font-size: 16px;
  color: white;
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  margin-bottom: 12px;

  ${media.desktop`
    font-size: 20px;
  `}
`;

export const CategorySeparator = styled.div`
  width: 100%;
  border-bottom: #2da5b2 0.5px solid;
  opacity: 0.75;
`;

export const ScreenButtonWrapper = styled.div`
  margin-top: 20px;
  align-self: end;
`;
